
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize IndexedDB for improved data persistence
const initializeStorage = () => {
  // Initialize feedback storage
  if (window.indexedDB) {
    const openFeedbackDB = window.indexedDB.open('adaaltFeedback', 1);
    
    openFeedbackDB.onupgradeneeded = (event) => {
      const db = openFeedbackDB.result;
      if (!db.objectStoreNames.contains('feedback')) {
        db.createObjectStore('feedback', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('pendingFeedback')) {
        db.createObjectStore('pendingFeedback', { keyPath: 'id' });
      }
    };
    
    // Initialize documents storage
    const openDocsDB = window.indexedDB.open('adaaltDocs', 1);
    
    openDocsDB.onupgradeneeded = (event) => {
      const db = openDocsDB.result;
      if (!db.objectStoreNames.contains('documents')) {
        const store = db.createObjectStore('documents', { keyPath: 'id' });
        store.createIndex('date', 'date', { unique: false });
      }
    };
  }
};

// Initialize storage as early as possible
initializeStorage();

// Check if we need to migrate from localStorage to IndexedDB
const migrateLocalStorageData = () => {
  try {
    // Migrate feedback data
    const feedbackData = JSON.parse(localStorage.getItem('adaaltFeedback') || '[]');
    if (feedbackData.length > 0 && window.indexedDB) {
      const request = window.indexedDB.open('adaaltFeedback', 1);
      
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(['feedback'], 'readwrite');
        const store = transaction.objectStore('feedback');
        
        feedbackData.forEach(item => {
          store.put(item);
        });
        
        console.log('Migrated feedback data from localStorage to IndexedDB');
      };
    }
    
    // Migrate documents data
    const docsData = JSON.parse(localStorage.getItem('adaaltBotDocs') || '[]');
    if (docsData.length > 0 && window.indexedDB) {
      const request = window.indexedDB.open('adaaltDocs', 1);
      
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(['documents'], 'readwrite');
        const store = transaction.objectStore('documents');
        
        docsData.forEach(item => {
          store.put(item);
        });
        
        console.log('Migrated documents data from localStorage to IndexedDB');
      };
    }
  } catch (error) {
    console.error('Error migrating data:', error);
  }
};

// Add a small timeout to ensure DOM is fully ready before rendering
// This helps prevent blank screens on some mobile browsers
setTimeout(() => {
  // Make sure the root element exists before trying to render
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    // Migrate data after app has rendered
    migrateLocalStorageData();
  } else {
    console.error('Root element not found! Check your HTML file for an element with id="root"');
  }
}, 0); // Minimal timeout to ensure proper event loop execution
